/* OPERATIONS = REDUX THUNKS

This file defines the public interface of the duck -- what can be dispatched from components
Simple operations are just about forwarding an action creator, ex: simpleQuack
Complex operations involve returning a thunk that dispatches multiple actions in a certain order, ex: complexQuack

*/

import * as actions from "./actions";
import store from '../store';
import { checkToken } from '../../utils/token-utils';

const adminGetMerchantPortalIndexOp = data => async dispatch => {
    try {
        const response = await dispatch(actions.adminGetMerchantPortalIndex(data));

        const filteredResponse = response.value.data.merchants.map(
            merchant => {
                return {
                    name: merchant.name,
                    merchantId: merchant.merchant_id,
                    id: merchant.id,
                };
            }
        );

        return filteredResponse;
    } catch (error) {
        throw error;
    }
}

const adminGetMerchantCoreIndexOp = data => async dispatch => {
    try {
        const bearerToken = await checkToken(store.getState().tokenReducer.tokens.bearerToken, true);

        const response = await dispatch(actions.adminGetMerchantCoreIndex({
            searchText: data,
            bearerToken,
        }));

        const filteredResponse = response.value.data.map(
            eachMerchant => {
                return {
                    name: eachMerchant.merchant.name,
                    merchantId: eachMerchant.merchant.id,
                };
            }
        );
        
        return filteredResponse;
    } catch (error) {
        throw error;
    }
}

export {
    adminGetMerchantPortalIndexOp,
    adminGetMerchantCoreIndexOp
};



// WEBPACK FOOTER //
// ./src/redux/admin/operations.js